<template>
  <div>
    <q-dialog 
      :visible="isVisible" 
      title="批量导入" 
      width="400px" 
      :innerScroll="false" 
      @close="onCancel"
      @cancel="onCancel"
      @confirm="onConfirm"
    >
      <div class="content-box">
        <el-form :model="uploadForm" :rules="rules" ref="formRef" label-width="80px">
          <el-form-item label="导入模版" prop="name">
            <el-button  size="small" type="primary" @click="download">下载模版</el-button>
          </el-form-item>
          <el-form-item label="选择文件" prop="file">
            <el-upload
              class="upload"
              :http-request="upload"
              :limit="1"
              action=""
              :before-remove="remove"
              accept=".xls,.xlsx"
              :before-upload="beforeUpload"
            >
              <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import { downloadFile } from '@/utils/downloadFile.js'
import { SUB_APP_CODE } from '@/api/api.js'
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    isShowImportDialog: {
      type: Boolean,
      default: false,
    },
    reportName: {
      type: String,
      default: ''
    },
    downloadConfig: {
      type: Object,
      default(){
        return {}
      }
    }
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.isShowImportDialog;
      },
      set(val) {
        this.$emit("update:isShowImportDialog", val);
      },
    },
  },
  data() {
    return {
      rules: {
        file: [
          { required: true, message: '请选择文件', trigger: ['blur'] },
        ],
      },
      uploadForm: {
        file: ''
      },
    };
  },
  methods: {
    download () {
      const { downloadName,name } = this.downloadConfig
       this.$api.common.downloadTemplate(downloadName).then(res => {
        if (res.success) {
          downloadFile(res.data.templatePath,name)
        }
      })
    },
    beforeUpload(file) {
      const excelTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
      if (!excelTypes.includes(file.type)) {
        this.$message.error('只能上传Excel文件');
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
        return false;
      }
      this.uploadForm.file = file;
      return true;
    },
    upload(file) { 
      this.uploadForm.file = file;
    },
    remove() {
      this.uploadForm.file = '';  
    },
    onConfirm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.submitUpload();
        }
      });
    },
    submitUpload() {
      const loading = this.$loading({
        lock: true,
        text: '文件导入中...',
        spinner: 'el-icon-loading'
      });
      const extData = {
        reportName: this.reportName,
        appCode: SUB_APP_CODE,
      };
      const { file } = this.uploadForm;
      this.$api.common.importFile(file.file, extData)
        .then((res) => {
          this.$notify.success({
            title: '成功',
            message: '导入数据成功'
          });
          this.onCancel();
        }).catch(err => {
          this.$message.error('导入数据失败，请重新导入！');
        }).finally(() => {
          loading.close();
        });
    },
    onCancel() {
      this.$refs.formRef.resetFields();
      this.isVisible = false;
    }
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-form-item {
  margin-bottom: 10px;
}
</style>
